import http from '../http-common';
import IUserData from '../type/comment-data';
import { BusinessPartnerProspect } from '@msdyn365-commerce/retail-proxy';

export interface BusinessPartnerProspectLog {
    content: BusinessPartnerProspect;
}
class UserDataService {
    public get(url: string) {
        return http.get<IUserData>(url);
    }

    public checkExist(url: string, data: IUserData) {
        return http.post<IUserData>(url, data);
    }

    public saveRegistrationLog(url: string, data: BusinessPartnerProspectLog) {
        return http.post<BusinessPartnerProspectLog>(url, data);
    }
}

export default new UserDataService();
